import { Component, DestroyRef, effect, inject, OnInit } from '@angular/core';
import { Sidebar } from './sidebar/sidebar';
import { RouterOutlet, Router, NavigationCancel, NavigationEnd, NavigationError, NavigationStart } from '@angular/router';
import { Footer } from "./footer/footer";
import { Header } from './header/header';
import { StateService } from '../shared/services/state-service';
import { IMenuItems } from '../shared/model/menuItems';
import { UserRole } from '../shared/model/role';
import { NavigationLoaderService } from '../shared/services/navigation-loader-service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Loader } from "../shared/components/loader/loader";
import { Sidebarservice } from '../shared/services/sidebarservice';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
  selector: 'app-layouts',
  imports: [Sidebar, RouterOutlet, Footer, Header, ProgressSpinnerModule, Loader],
  templateUrl: './layouts.html',
  styleUrl: './layouts.scss',
})
export class Layouts implements OnInit {
  stateService = inject(StateService);
  private router = inject(Router);
  navigationLoader = inject(NavigationLoaderService);
  private sidebarService = inject(Sidebarservice);
  private destroyRef = inject(DestroyRef);

  role: UserRole = UserRole.USER;
  menuItems: IMenuItems[] = [];
  activeMenu =  this.sidebarService.activeMenu;

  constructor() {
    effect(() => {
      const isOpen = this.stateService.sidebarOpen();
      const isMobile = window.innerWidth < 991;

      if (isMobile && isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
  }

  ngOnInit(): void {
    this.role = this.sidebarService.getRole();
    this.menuItems = this.sidebarService.getmenuItems();
    this.updateActiveMenu()
  }

  updateActiveMenu() {
    const menu = this.menuItems.find(item =>
      this.router.isActive(item.route, {
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored'
      })
    );
    // this.sidebarService.activeMenu.set(menu ?? null)
  }

  closeSidebar(): void {
    if (window.innerWidth < 991) {
      this.stateService.sidebarOpen.set(false);
    }
  }

  openSidebar() {
    this.stateService.openSidebar()
  }

 



}
